import ButtonGroup from 'reactstrap/es/ButtonGroup';
import Button from 'reactstrap/es/Button';
import { useLocation, useHistory } from 'react-router-dom';

export function NevigationAnalytics ({ basePath }) {
	const location = useLocation();
	const history = useHistory();
	const currentPath = location.pathname.replace(basePath, '');

	function goTo (...path) {
		return () => history.push(`${basePath}${path.join('/')}`);
	}

	return (
		<div className="analytics-navigation">
			<ButtonGroup className="group-navigation">
				<Button disabled={!currentPath || currentPath === '/'} onClick={goTo()}>Продажа товаров на сайте</Button>
				<Button disabled={currentPath === 'amocrm'} onClick={goTo('amocrm')}>Продажи с AmoCRM</Button>
				<Button disabled={currentPath === 'clients'} onClick={goTo('clients')}>Клиенты</Button>
				<Button disabled={currentPath === 'promocode'} onClick={goTo('promocode')}>Промокоды</Button>
			</ButtonGroup>
		</div>
	);
}
